const IconCheck = (): JSX.Element => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.09091 11.0746L1.27273 6.68657L0 8.14925L5.09091 14L16 1.46269L14.7273 0L5.09091 11.0746Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconCheck;
